import Vue from "vue";
import router from "./router.js";
import App from "./app.vue";
import store from './store' // 引入store
import "vue2-toast/lib/toast.css";
import 'mint-ui/lib/style.css'
import Toast from "vue2-toast";
import Vant from 'vant';
import 'vant/lib/index.css';
import { Overlay } from 'vant';
import "../../styles/index.scss"
import VueWechatTitle from 'vue-wechat-title'
import i18n from "./i18n/i18n"
import langTest from "@/directives/index.js"

Vue.use(langTest)
Vue.use(Toast);
Vue.use(Vant);
Vue.use(Overlay);
Vue.use(VueWechatTitle)
const vue = new Vue({
    el: "#app",
    router,
    store,
    i18n,
    render: h => h(App)
});

